import { render, staticRenderFns } from "./CardTransactions2.vue?vue&type=template&id=8dc18dbe&"
import script from "./CardTransactions2.vue?vue&type=script&lang=js&"
export * from "./CardTransactions2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports